module.exports = __webpack_public_path__ + "static/media/user-solid .81bde98f.svg";